import { c as _c } from "react/compiler-runtime";
import snappPayLogo from "@website/accommodation-ui/tour-card/assets/snapppay-logo.svg";
import { TourCardBadgeTypes } from "@website/accommodation-ui/tour-card/tour-card-snapp-pay-badge/types";
import { LazyImage } from "@website/ui/lazy-image";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { FC } from "react";
export const Index: FC<TourCardBadgeTypes> = properties => {
  const $ = _c(17);
  const {
    pricing
  } = properties;
  const t0 = pricing.priceOff || pricing.price;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    const price = (t0 / 40).toFixed(0);
    t5 = "text-[#008EFA] md:px-4";
    t3 = "flex justify-between rounded bg-[#008EFA12] p-2 px-4 text-sm lg:text-lg";
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex items-center"><div className="bg-ventures-fin-tech size-[16px] rounded-sm py-1.5 text-center"><LazyImage src={snappPayLogo?.src} /></div><p className="pr-2 text-xs">رزرو با قسط اول از</p></div>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t1 = "text-sm";
    t2 = numberConvert(numberSeparator(price), {
      locale: "fa"
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t2) {
    t6 = <p className={t1}>{t2}{" "}تومان</p>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};